/**
 * iKSORIS - WWW
 * SoftCOM Spółka jawna - http://www.softcom.wroc.pl
 * @author SoftCOM Spółka jawna <biuro@softcom.wroc.pl>
 * @copyright Copyright (c) 2010-2014, SoftCOM Spółka jawna
 */

class Modal {
  constructor(modalId, toggles = []) {
    this.modalId = modalId;
    this.toggles = toggles;
    this.body = document.querySelector("body");
    this._toggleDataAttributes = {
      form: {
        node: null,
        submit: false,
      },
      textBody: "",
      textConfirm: "Tak",
      textDismiss: "Nie",
      textHeader: "",
      url: "#",
    };
    this.bootstrapModal = null;
    this.unloadFunction = null;
    this.init();
  }

  get toggleDataAttributes() {
    return this._toggleDataAttributes;
  }

  set toggleDataAttributes(object) {
    Object.assign(this._toggleDataAttributes, object);
    this.instance();
  }

  initBootstrapModalInstance() {
    this.bootstrapModal = new bootstrap.Modal(
      document.getElementById(this.modalId)
    );

    // Events
    this.initBootstrapModalEvents(this.bootstrapModal._element);
  }

  initBootstrapModalEvents(element) {
    const _this = this;

    element.addEventListener("shown.bs.modal", function (event) {
      _this.unloadFunction = function () {
        _this.bootstrapModal.hide();
      };

      // Add event
      window.addEventListener("unload", _this.unloadFunction, false);
    });

    element.addEventListener("hidden.bs.modal", function (event) {
      // Removal of existing instance and events
      if (Boolean(_this.bootstrapModal)) {
        element.remove();
        delete _this.bootstrapModal;
      }

      // Remove of existing event
      window.removeEventListener("unload", _this.unloadFunction, false);
    });
  }

  events() {
    const _this = this;

    if (this.toggles.length > 0) {
      this.toggles.forEach(function (element, index) {
        element.addEventListener(
          "click",
          function (event) {
            event.preventDefault();

            _this.toggleDataAttributes = (function (target) {
              const object = Object.assign({}, target.dataset);
              const newObject = {};

              for (const key in object) {
                if (Object.hasOwnProperty.call(object, key)) {
                  if (key !== "toggle") {
                    newObject[key] = object[key];
                  }
                }
              }

              if (target.getAttribute("href")) {
                newObject.url = target.getAttribute("href");
                newObject.form = {
                  node: null,
                  submit: false,
                };
              }

              if (target.getAttribute("type") === "submit") {
                newObject.form = {
                  node: target.form,
                  submit: true,
                };
                newObject.url = "#";
              }

              return newObject;
            })(event.target.closest("a"));
          },
          false
        );
      });
    }
  }

  getTemplate() {
    return `
                <div aria-hidden="true" aria-labelledby="modal-Label" class="modal fade" id="${
                  this.modalId
                }" tabindex="-1">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                ${(function (title) {
                                  if (title !== "") {
                                    return `<h5 class="modal-title" id="modal-label">${title}</h5>`;
                                  } else {
                                    return ``;
                                  }
                                })(this.toggleDataAttributes.textHeader)}
                                <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"></button>
                            </div>
                            <div class="modal-body">${
                              this.toggleDataAttributes.textBody
                            }</div>
                            <div class="modal-footer">
                                <button class="btn btn-secondary" data-bs-dismiss="modal" type="button">${
                                  this.toggleDataAttributes.textDismiss
                                }</button>
                                ${(function (toggleDataAttributes) {
                                  if (toggleDataAttributes.form.submit) {
                                    return `<button class="btn btn-primary" type="submit" form="${toggleDataAttributes.form.node.id}">${toggleDataAttributes.textConfirm}</button>`;
                                  } else {
                                    return `<a class="btn btn-primary" href="${toggleDataAttributes.url}">${toggleDataAttributes.textConfirm}</a>`;
                                  }
                                })(this.toggleDataAttributes)}
                            </div>
                        </div>
                    </div>
                </div>`;
  }

  instance() {
    this.body.insertAdjacentHTML("beforeend", this.getTemplate());
    this.initBootstrapModalInstance();
    this.bootstrapModal.show();
  }

  show(config = {}) {
    for (const key in this.toggleDataAttributes) {
      if (!Object.hasOwnProperty.call(config, key)) {
        switch (key) {
          case "form":
            config.form = {
              node: null,
              submit: false,
            };
            break;
          case "textBody":
            config.textBody = "";
            break;
          case "textConfirm":
            config.textConfirm = "";
            break;
          case "textDismiss":
            config.textDismiss = "";
            break;
          case "textHeader":
            config.textHeader = "";
            break;
          case "url":
            config.url = "#";
            break;
        }
      }
    }

    this.toggleDataAttributes = config;
  }

  init() {
    this.events();
  }
}

export { Modal };
